module.exports = __webpack_public_path__ + "img/syn.cbc61a47.svg";